export const firebaseConfig = {
  apiKey: "AIzaSyCnZMqHWoLXJpIAdS91_Z1_t68HWJTdO-I",
  authDomain: "earlybird-3ecbc.firebaseapp.com",
  databaseURL: "https://earlybird-3ecbc.firebaseio.com",
  projectId: "earlybird-3ecbc",
  storageBucket: "",
  messagingSenderId: "669831413024",
  appId: "1:669831413024:web:5e418e3c6f12bb8fb9ab45"
};